<template>
  <div ref="appRef" class="tower-show-page" id="towerInfo">
    <div class="headBack"></div>
    <div class="headFront">
      <p class="headTitle textColorGradient">塔机可视化模型</p>
    </div>
    <div class="leftScreen">
      <div class="screen-content">
        <div class="line"></div>
        <div class="machineStatus">
          <div class="machineStatusTitle">
            <div class="verticalBar"></div>
            <div class="verticalBarTitle textColorGradient">设备状态</div>
          </div>
          <div class="machineStatusContent">
            <div>
              <p>设备总数</p>
              <!-- <p>
                <span><numberGrow :startVal='0' :value='statics.sum' :time=5></numberGrow></span
                >/台
              </p> -->
              <p>
                <span>{{ statics.count }}</span>/台
              </p>
            </div>
            <div>
              <p>在线设备</p>
              <p>
                <span>{{ statics.online }}</span>/台
              </p>
            </div>
            <div>
              <p style="color: #fffd52">离线设备</p>
              <p>
                <span>{{ statics.offline }}</span>/台
              </p>
            </div>
            <div>
              <p>塔机监控</p>
              <p>
                <span>{{ statics.cameraCount }}</span>/台
              </p>
            </div>
            <div>
              <p style="color: #ff4d52">报警设备</p>
              <p>
                <span>{{ statics.alarmCount }}</span>/台
              </p>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="detectingParameter">
          <div class="machineStatusTitle">
            <div class="verticalBar"></div>
            <div class="verticalBarTitle">
              <span class="textColorGradient">监测参数</span>
              <span style="display: inline-block; margin: 0 0.5vw">-</span>
              <span style="display: inline-block; font-size: 0.834rem">
                {{ tower.name + '(' + tower.deviceId + ')' }}
              </span>
            </div>
          </div>
          <div class="checkContent">
            <div class="check-charts">
              <div>
                <dataItem name="塔顶风速" :total="towerHightInfo.speedMax" :diff="diff" :value="valData.windspeed"
                  :startColor="initCharts[0]" :endColor="initCharts[0]" unit="m/s"></dataItem>
              </div>
              <div>
                <dataItem name="吊钩离地" :total="towerHightInfo.hookHeightMax"
                  :value="selectRound(datas.heightSettingBean.towerHeight - valData.hight)" :diff="diff"
                  :startColor="initCharts[1]" :endColor="initCharts[1]" unit="m"></dataItem>
              </div>
              <div>
                <dataItem name="小车幅度" :total="towerHightInfo.carRangeMax" :diff="diff" :value="valData.radius"
                  :startColor="initCharts[2]" :endColor="initCharts[2]" unit="m"></dataItem>
              </div>
              <div>
                <dataItem name="大臂回转" :total="towerHightInfo.upperArmMax" :value="valData.angle" :diff="diff"
                  :startColor="initCharts[3]" :endColor="initCharts[3]" unit="°"></dataItem>
              </div>
              <div>
                <dataItem name="起重力矩" :total="towerHightInfo.loadMomentMax" :value="0" :diff="diff"
                  :startColor="initCharts[4]" :endColor="initCharts[4]" unit="%"></dataItem>
              </div>
              <div>
                <!-- :total="towerHightInfo.liftingWeightMax" -->
                <dataItem name="吊起重量" :total="valData.ratedWeight" :value="valData.loadweightr" :diff="diff"
                  :startColor="initCharts[5]" :endColor="initCharts[5]" unit="T"></dataItem>
              </div>
              <div>
                <dataItem name="姿态倾角X" :total="towerHightInfo.angleMax" :value="valData.fall" :diff="diff" :abs="true"
                  :startColor="initCharts[6]" :endColor="initCharts[6]" unit="°"></dataItem>
              </div>
            </div>
            <div class="rightCheckContent">
              <div class="rightCheckContentTitle"></div>
              <div class="rightCheckContentInfo">
                <div class="rightCheckContentInfoItem">
                  <div>
                    <img src="../../../assets/image/tower/bigScreen/towerBodyHeight.png" alt="" />
                    <p>
                      塔身高度：<span style="font-size: 1.04rem">{{
                        datas.heightSettingBean.towerHeight || 0
                      }}</span>m
                    </p>
                  </div>
                </div>
                <div class="rightCheckContentInfoItem">
                  <div>
                    <img src="../../../assets/image/tower/bigScreen/jibLength.png" alt="" />
                    <p>
                      起重臂长：<span style="font-size: 1.04rem">{{
                        datas.rangeSettingBean.towerArmLength || 0
                      }}</span>m
                    </p>
                  </div>
                </div>
                <div class="rightCheckContentInfoItem">
                  <div>
                    <p>
                      垂直碰撞距离：<span style="font-size: 1.04rem">{{
                        valData.crashHeight || 0
                      }}</span>m
                    </p>
                  </div>
                </div>
                <div class="rightCheckContentInfoItem">
                  <div>
                    <p>
                      水平碰撞距离：<span style="font-size: 1.04rem">{{
                        valData.crosswiseCrashHeight || 0
                      }}</span>m
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rightScreen">
      <div class="right-screen-content">
        <div class="line"></div>
        <div class="machineDetails">
          <div class="machineStatusTitle">
            <div class="verticalBar"></div>
            <div class="verticalBarTitle textColorGradient">设备详情</div>
          </div>
          <div class="machineDetailsInfo">
            <div>
              <p>
                设备名称:<span>{{ towerInfo.name }}</span>
              </p>
            </div>
            <div>
              <p>
                设备编号:<span>{{ towerInfo.deviceId }}</span>
              </p>
            </div>
            <div>
              <p>
                型号规格:<span>{{ towerInfo.deviceSpecification }}</span>
              </p>
            </div>
            <div>
              <p>
                设备厂家:<span>{{ towerInfo.machTypeName }}</span>
              </p>
            </div>
            <div>
              <p>
                安装单位:<span>{{ towerInfo.installUnit }}</span>
              </p>
            </div>
            <div>
              <p>
                人脸识别机编号:<span>{{ towerInfo.attendanceSn }}</span>
              </p>
            </div>
            <div>
              <p>
                所在班组:<span>{{ towerInfo.teamsName }}</span>
              </p>
            </div>
            <div>
              <p>
                安装时间:<span>{{ towerInfo.createDate }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="earlyWarningRecord">
          <div class="machineStatusTitle">
            <div class="verticalBar"></div>
            <div class="verticalBarTitle textColorGradient">其它预警记录</div>
            <div class="earlyWarningSetting" @click="towerConfig">设置</div>
            <div class="demonstration" v-if="deviceId == 'ts2022121001618'" @click="towerDemonstration">
              演示
            </div>
          </div>
          <div class="earlyWarningRecordInfo">
            <div :class="{ move: animate1 }" v-if="warningList.length">
              <div class="warningInfo between-center" v-for="(item, index) in warningList"
                :key="index" @mouseenter="onMouseEnter1(index)" @mouseleave="onMouseLeave1"
                :class="{
                  pointer: index === currentIndex1,
                  alertColor: item.typeName.endsWith('预警'),
                  alarmColor: item.typeName.endsWith('报警'),
                }"
              >
                <img style="width: 2.8vh;height: 2.8vhvertical-align: middle;margin-left: 0.1vw"
                  :src="httpCtx + item.screenIcon" alt=""
                />
                <p style="width: 5.5vw">{{ item.typeName }}</p>
                <p style="width: 3.8vw">{{ item.value }}{{ item.unit }}</p>
                <p>{{ item.createDate }}</p>
              </div>
            </div>
            <div v-else style="margin-top: 0">
              <div style="width: 21.5vw">
                <div style="display: flex; align: center">
                  <img style="width: 14vh;height: 14vh;margin: 0 auto;display: inline-block;"
                    src="../../../assets/image/tower/bigScreen/noContent.png"
                  />
                </div>
                <div style="text-align: center;color: #1f7995;font-size: 0.834rem;font-weight: bold">
                  暂无数据
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="earlyWarningRecord">
          <div class="machineStatusTitle">
            <div class="verticalBar"></div>
            <div class="verticalBarTitle textColorGradient">碰撞预警记录</div>
          </div>
          <div class="earlyWarningRecordInfo">
            <div :class="{ move: animate2 }"  v-if="crashWarningList.length">
              <div class="warningInfo between-center" v-for="(item, index) in crashWarningList"
                :key="index" @mouseenter="onMouseEnter2(index)" @mouseleave="onMouseLeave2"
                :class="{
                  pointer: index === currentIndex2,
                  alertColor: item.typeName.endsWith('预警'),
                  alarmColor: item.typeName.endsWith('报警'),
                }"
              >
                <img style="width: 2.8vh;height: 2.8vhvertical-align: middle;margin-left: 0.1vw"
                  :src="httpCtx + item.screenIcon" alt=""
                />
                <p style="width: 5.5vw">{{ item.typeName }}</p>
                <p style="width: 3.8vw">{{ item.value }}{{ item.unit }}</p>
                <p>{{ item.createDate }}</p>
              </div>
            </div>
            <div v-else style="margin-top: 0">
              <div style="width: 21.5vw">
                <div style="display: flex; align: center">
                  <img style="width: 14vh;height: 14vh;margin: 0 auto;display: inline-block;"
                    src="../../../assets/image/tower/bigScreen/noContent.png"
                  />
                </div>
                <div style="text-align: center;color: #1f7995;font-size: 0.834rem;font-weight: bold">
                  暂无数据
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="personList">
          <div class="machineStatusTitle">
            <div class="verticalBar"></div>
            <div class="verticalBarTitle textColorGradient">塔机班组人员列表</div>
          </div>

          <div class="personListInfo">
            <div class="personListInfoTitle">
              <div class="personName">姓名</div>
              <div class="idCard">身份证号</div>
              <div class="phone">手机号码</div>
            </div>
            <div class="personListInfoContent">
              <div :class="{
                personMove: personMoveFlag,
              }" v-if="!personNonImg">
                <div class="personInfo" v-for="(item, index) in teamsPersonList" :key="index" :class="{
                  personEnter: index === personCurrentIndex,
                  personNoEnter: index !== personCurrentIndex,
                }" @mouseenter="onPersonEnterTd(index)" @mouseleave="onPersonLeaveTd">
                  <div class="personName">{{ item.name }}</div>
                  <div class="idCard">{{ item.idcard }}</div>
                  <div class="phone">{{ item.phone }}</div>
                </div>
              </div>
              <div v-else>
                <div style="width: 21.5vw">
                  <div style="display: flex; align: center">
                    <img src="../../../assets/image/tower/bigScreen/noContent.png" style="
                                width: 14vh;
                                height: 14vh;
                                margin: 0 auto;
                                display: inline-block;
                              " />
                  </div>
                  <div style="
                              text-align: center;
                              color: #1f7995;
                              font-size: 0.834rem;
                              font-weight: bold;
                            ">
                    暂无数据
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <iframe id="iframe" width="100%" allowfullscreen="true" :src="myURL" frameborder="no"
      style="border: 0; height: 100%"></iframe>
    <div id="msg" class="Box" v-if="msgStatus">
      <div :class="{
        contentBox: true,
        success: type === 'success',
        error: type === 'error',
        info: type === 'info',
      }">
        <!-- 这里的图标用的是elementUI的图标 -->
        <!-- <i class="el-icon-success icon success" v-if="type === 'success'"></i>
        <i class="el-icon-error icon error" v-if="type === 'error'"></i>
        <i class="el-icon-warning icon info" v-if="type === 'info'"></i> -->
        <span> {{ msg }}</span>
      </div>
    </div>
    <div class="warningConfig">
      <div v-if="addFormVisible" style="
                  width: 2vh;
                  height: 2vh;
                  transform: rotate(180deg);
                  border: 0.2vh solid #3fcffc;
                  box-shadow: 0 0.4vh 1.2vh 0 #3fcffc;
                  position: absolute;
                  z-index: 200;
                  top: 0;
                  left: 0;
                "></div>
      <el-dialog title="预警设置" :visible.sync="addFormVisible" :append-to-body="false" :lock-scroll="false" top="25vh"
        width="40%" :close-on-click-modal="false" @close="backInitSetting">
        <!-- <div
        style="
          width: 20px;
          height: 20px;
          transform: rotate(180deg);
          border: 2px solid #3fcffc;
          box-shadow: 0px 4px 12px 0px #3fcffc;
          position: absolute;
          z-index: 10000
        "
      ></div>
       <div
        style="
          width: 20px;
          height: 20px;
          transform: rotate(180deg);
          border: 2px solid #3fcffc;
          box-shadow: 0px 4px 12px 0px #3fcffc;
          position: absolute;
          z-index: 10000
        "
      ></div>
       <div
        style="
          width: 20px;
          height: 20px;
          transform: rotate(180deg);
          border: 2px solid #3fcffc;
          box-shadow: 0px 4px 12px 0px #3fcffc;
          position: absolute;
          z-index: 10000
        "
      ></div> -->
        <el-row>
          <el-col :span="24">
            <el-form size="mini" label-width="6vw">
              <el-row>
                <el-col :span="11"><el-form-item label="吊钩高度">
                    <el-input placeholder="请输入预警值" v-model="addfrom.heightWarning"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">m</p>
                </el-col>
                <el-col :span="11">
                  <el-form-item class="formItemInfo">
                    <el-input placeholder="报警值" v-model="addfrom.heightAlarm"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">m</p>
                </el-col>
              </el-row>
              <!-- === -->
              <el-row>
                <el-col :span="11"><el-form-item label="小车幅度">
                    <el-input placeholder="请输入预警值" v-model="addfrom.radiusWarning"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">m</p>
                </el-col>
                <el-col :span="11">
                  <el-form-item class="formItemInfo">
                    <el-input placeholder="报警值" v-model="addfrom.radiusAlarm"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">m</p>
                </el-col>
              </el-row>
              <!-- === -->
              <el-row>
                <el-col :span="11"><el-form-item label="大臂回转">
                    <el-input placeholder="请输入预警值" v-model="addfrom.angleWarning">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">°</p>
                </el-col>
                <el-col :span="11">
                  <el-form-item class="formItemInfo">
                    <el-input placeholder="报警值" v-model="addfrom.angleAlarm"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">°</p>
                </el-col>
              </el-row>
              <!-- === -->
              <!-- <el-row>
                <el-col :span="11"
                  ><el-form-item label="起重力矩">
                    <el-input
                      placeholder="请输入预警值"
                      v-model="addfrom.lijupercentWarning"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">%</p>
                </el-col>
                <el-col :span="11">
                  <el-form-item class="formItemInfo">
                    <el-input
                      placeholder="报警值"
                      v-model="addfrom.lijupercentAlarm"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">%</p>
                </el-col>
              </el-row> -->
              <!-- === -->
              <el-row>
                <el-col :span="11"><el-form-item label="吊起重量">
                    <el-input placeholder="请输入预警值" v-model="addfrom.loadweightrWarning"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">T</p>
                </el-col>
                <el-col :span="11">
                  <el-form-item class="formItemInfo">
                    <el-input placeholder="报警值" v-model="addfrom.loadweightrAlarm"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">T</p>
                </el-col>
              </el-row>
              <!-- === -->
              <el-row>
                <el-col :span="11"><el-form-item label="姿态倾角">
                    <el-input placeholder="请输入预警值 " v-model="addfrom.fallWarning"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">°</p>
                </el-col>
                <el-col :span="11">
                  <el-form-item class="formItemInfo">
                    <el-input placeholder="报警值" v-model="addfrom.fallAlarm"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">°</p>
                </el-col>
              </el-row>
              <!-- === -->
              <el-row>
                <el-col :span="11"><el-form-item label="塔顶风速">
                    <el-input placeholder="请输入预警值" v-model="addfrom.windspeedWarning"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">m/s</p>
                </el-col>
                <el-col :span="11">
                  <el-form-item class="formItemInfo">
                    <el-input placeholder="报警值" v-model="addfrom.windspeedAlarm"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">m/s</p>
                </el-col>
              </el-row>
              <!-- === -->
              <el-row>
                <el-col :span="11"><el-form-item label="垂直碰撞距离">
                    <el-input placeholder="请输入预警值" v-model="addfrom.crashWarning"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">m</p>
                </el-col>
                <el-col :span="11">
                  <el-form-item class="formItemInfo">
                    <el-input placeholder="报警值" v-model="addfrom.crashAlarm"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">m</p>
                </el-col>
              </el-row>
              <!-- === -->
              <el-row>
                <el-col :span="11"><el-form-item label="平面碰撞距离">
                    <el-input placeholder="请输入预警值" v-model="addfrom.crosswiseCrashWarning"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">m</p>
                </el-col>
                <el-col :span="11">
                  <el-form-item class="formItemInfo">
                    <el-input placeholder="报警值" v-model="addfrom.crosswiseCrashAlarm"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <p class="itemUnit">m</p>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
        <div style="display: flex; justify-content: center; margin-top: 2vh">
          <div style="margin-right: 2vw" class="cancle" @click="addFormVisible = false">
            取 消
          </div>
          <div class="confirm" @click="sumbitAddRow('addForm')">确 定</div>
        </div>
      </el-dialog>
    </div>
    <div class="alarmInfo" v-if="alarmVisible">
      {{ alarmInfo }}
    </div>
  </div>
</template>

<script>
import myHttp from "../../../untils/port";
import util from "../../../untils/util";
import dataItem from "./components/CustomProgressBar.vue";
import numberGrow from "./components/CustomNumberJump.vue";
import base from "../../../untils/base";

export default {
  components: {
    dataItem,
    numberGrow,
  },
  data() {
    return {
      myURL: "/webgl/towerShow.html",
      httpCtx: base.httpCtx,
      fullscreen: false,
      deviceId: "",
      projectId: "",
      addFormVisible: false,
      alarmInfo: "",
      alarmVisible: false,
      addfrom: {
        //机器序列号
        id: "",
        //项目id
        projectId: util.session.get("groupId"),
        //设备名称
        name: "",
        //吊钩高度预警
        heightWarning: "",
        //吊钩高度报警
        heightAlarm: "",
        //小车幅度预警
        radiusWarning: "",
        //小车幅度报警
        radiusAlarm: "",
        //大臂回转预警
        angleWarning: "",
        //大臂回转报警
        angleAlarm: "",
        //吊起重量预警
        loadweightrWarning: "",
        //吊起重量报警
        loadweightrAlarm: "",
        //力矩百分比预警
        lijupercentWarning: "",
        //力矩百分比报警
        lijupercentAlarm: "",
        //姿态倾角预警
        fallWarning: "",
        //姿态倾角报警
        fallAlarm: "",
        //塔顶风速预警
        windspeedWarning: "",
        //塔顶风速报警
        windspeedAlarm: "",
        //垂直碰撞预警
        crashWarning: "",
        //垂直碰撞报警
        crashAlarm: "",
        //平面碰撞预警
        crosswiseCrashWarning: "",
        //平面碰撞报警
        crosswiseCrashAlarm: "",
      },
      diff: 2,
      tower: {
        name: "",
        deviceId: "",
      },
      type: "success",
      msg: "操作成功",
      msgStatus: false,
      msgTimeOutId: "",
      towerInfo: {},
      teamsPersonList: [],
      tempTeamsPersonList: [],
      allTeamsPersonList: [],
      charsColors: [
        [127, 232, 100],
        [255, 77, 82],
        [255, 77, 82],
      ],
      initCharts: [
        [127, 232, 100],
        [127, 232, 100],
        [127, 232, 100],
        [127, 232, 100],
        [127, 232, 100],
        [127, 232, 100],
        [127, 232, 100],
      ],
      statics: {
        count: 0,
        online: 0,
        offline: 0,
        cameraCount: 0,
        alarmCount: 0,
      },
      warningList: [],
      crashWarningList: [],
      personNonImg: false,
      datas: {
        deviceSettingBean: {
          cameraType: false,
          cardNumber: "",
          hookVisualization: "",
          mailingAddress: "",
          openFace: false,
          serverAddress: "",
        },
        dipAngleSettingBean: {
          dipAngleEarlyWarning: "",
          dipAngleWarning: "",
          dipAngleX: "",
          dipAngleY: "",
        },
        heightSettingBean: {
          heightCoefficientValue: "",
          heightEarlyWarning: "",
          heightInitialDown: "",
          heightInitialUp: "",
          heightSensorDown: "",
          heightSensorUp: "",
          heightWarning: "",
          towerHeight: "",
        },
        rangeSettingBean: {
          rangeCoefficientValue: "",
          rangeEarlyWarning: "",
          rangeFar: "",
          rangeNear: "",
          rangeSensorFar: "",
          rangeSensorNear: "",
          rangeWarning: "",
          towerArmLength: "",
        },
        rotationSettingBean: {
          rotationEarlyWarning: "",
          rotationSensorValue: "",
          rotationWarning: "",
        },
        weightSettingBean: {
          weightCoefficientValue: "",
          weightEarlyWarning: "",
          weightNoLoadSensorValue: "",
          weightRated: "",
          weightSensorValue: "",
          weightValue: "",
          weightWarning: "",
        },
        windSpeedSettingBean: {
          windSpeedEarlyWarning: "",
          windSpeedWarning: "",
        },
      },
      copyDatas: {
        deviceSettingBean: {
          cameraType: false,
          cardNumber: "",
          hookVisualization: "",
          mailingAddress: "",
          openFace: false,
          serverAddress: "",
        },
        dipAngleSettingBean: {
          dipAngleEarlyWarning: "",
          dipAngleWarning: "",
          dipAngleX: "",
          dipAngleY: "",
        },
        heightSettingBean: {
          heightCoefficientValue: "",
          heightEarlyWarning: "",
          heightInitialDown: "",
          heightInitialUp: "",
          heightSensorDown: "",
          heightSensorUp: "",
          heightWarning: "",
          towerHeight: "",
        },
        rangeSettingBean: {
          rangeCoefficientValue: "",
          rangeEarlyWarning: "",
          rangeFar: "",
          rangeNear: "",
          rangeSensorFar: "",
          rangeSensorNear: "",
          rangeWarning: "",
          towerArmLength: "",
        },
        rotationSettingBean: {
          rotationEarlyWarning: "",
          rotationSensorValue: "",
          rotationWarning: "",
        },
        weightSettingBean: {
          weightCoefficientValue: "",
          weightEarlyWarning: "",
          weightNoLoadSensorValue: "",
          weightRated: "",
          weightSensorValue: "",
          weightValue: "",
          weightWarning: "",
        },
        windSpeedSettingBean: {
          windSpeedEarlyWarning: "",
          windSpeedWarning: "",
        },
      },
      valData: {
        //实时数据列表
        radius: 0, //幅度
        lijupercent: 0, //力矩
        ratedWeight: 10, //额定吊重
        loadweightr: 0, //起吊吊重
        hight: 0, //吊钩与大臂距离
        fall: 0, //前倾角
        angle: 0, //大臂回转
        windspeed: 0, //风速
        crashHeight: null, //垂直碰撞距离
        crosswiseCrashHeight: null, //水平碰撞距离
      },
      towerHightInfo: {
        speedMax: 10,
        hookHeightMax: 50,
        carRangeMax: 50,
        upperArmMax: 360,
        loadMomentMax: 100,
        liftingWeightMax: 10,
        angleMax: 90,
      },
      animate1: false,
      animate2: false,
      warningTimeOutId: undefined,
      crashWarningTimeOutId: undefined,
      warningConstantCount: 5,
      warningIntervalId: undefined,
      crashWarningIntervalId: undefined,
      tempWarnList: [],
      currentIndex1: -1,
      currentIndex2: -1,
      personMoveFlag: false,
      personTimeOutId: "",
      personConstantCount: 12,
      personIntervalId: "",
      personCurrentIndex: -1,
      towerDataType: 1,
    };
  },
  created() {
    this.projectId = util.session.get("groupId");
    let t =
      window.devicePixelRatio ||
      window.screen.deviceXDPI ||
      window.screen.logicalXDPI; // 获取下载的缩放 125% -> 1.25    150% -> 1.5
    let zoom = 1;
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      if (t != 1) {
        // 如果在笔记本中用IE浏览器打开 则弹出提示
        alert(
          "您的设备对显示进行放大导致页面显示不完全,请调整后打开/或用其他浏览器"
        );
      }
    } else {
      if (t != 1) {
        // 如果进行了缩放，也就是不是1
        if (t == 1.5) {
          this.diff = -2;
        }
        if (t == 1.25) {
          this.diff = -1.2;
        }
      }
    }
    // const preferWidth = 1920; //预期值
    // if (t > 1) {
    //   // 用户有放大，我们再做缩放
    //   const screenWidth = window.screen.width; // 我们是针对屏幕进行缩放的，不是针对浏览器
    //   if (screenWidth < preferWidth) {
    //     // 屏幕小于预期值才执行
    //     zoom = screenWidth / preferWidth; // 得到缩放倍数
    //     document.documentElement.style.zoom = zoom;
    //   }
    // }
    if (t == 1.25) {
      zoom = 1.1;
    } else if (t == 1.5) {
      zoom = 1.2;
    } else {
      zoom = t;
    }
    zoom = t;
    zoom = 1;
    //设置css变量值
    document.documentElement.style.setProperty("--zoom", zoom);
    document.documentElement.style.setProperty(
      "--full-height",
      window.innerHeight
    );
  },
  mounted() {
    this.findTowerBigScreenStatistics();
    window.addEventListener("keydown", this.keyDown, false);
    window.addEventListener("message", this.handleMessage);
    this.$message({
      showClose: true,
      dangerouslyUseHTMLString: true,
      message: "<p>按下F11可以切换全屏/正常显示</p>",
    });
  },
  beforeDestroy() { },
  methods: {
    selectRound(num) {
      if (num < 0) return 0;
      return Math.round(num * 100) / 100;
    },

    showAduit(text) {
      new Audio(
        'http://tts.baidu.com/text2audio?cuid=baiduid&ctp=1&vol=15&lan=zh&per=1&pit=9&spd=6&tex=' + text + '&tok=' + base.videoToken
      ).play()
    },
    towerDemonstration() {
      let data = null;
      if (this.towerDataType === 1) {
        data = {
          alarmReason: "0",
          amplitude: 35.0,
          crashHeight: "57.8",
          fall: -0.800000011920929,
          height: 40.0,
          rotation: 200.099998474121094,
          status: "1",
          tilt: -0.20000000298023224,
          torque: 92,
          weight: 0.0,
          windspeed: 3.0,
        };
        this.towerDataType++;
      } else if (this.towerDataType === 2) {
        data = {
          alarmReason: "0",
          amplitude: 35.0,
          crashHeight: "47",
          fall: -0.800000011920929,
          height: 40.0,
          rotation: 310.099998474121094,
          status: "1",
          tilt: -0.20000000298023224,
          torque: 92,
          weight: 0.0,
          windspeed: 3.0,
        };
        this.towerDataType++;
      } else {
        data = {
          alarmReason: "0",
          amplitude: 35.0,
          crashHeight: "20",
          fall: -0.800000011920929,
          height: 40.0,
          rotation: 340.099998474121094,
          status: "1",
          tilt: -0.20000000298023224,
          torque: 92,
          weight: 0.0,
          windspeed: 3.0,
        };
        this.towerDataType = 1;
      }
      let towerData = { imei: "ts2022121001618", data: JSON.stringify(data) };
      myHttp.uploadTowerDataInfo(towerData).then(
        (resp) => {
          this.msg = resp.data.msg;
          if (resp.data.code == 200) {
            // this.$message.success(resp.data.msg);
            this.type = "success";
            this.addFormVisible = false;
          } else {
            // this.$message.error(resp.data.msg);
            this.type = "error";
          }
          this.alertMsg();
        },
        (err) => { }
      );
    },
    alertMsg() {
      this.msgStatus = true;
      if (this.msgTimeOutId != "") {
        clearTimeout(this.msgTimeOutId);
        this.msgTimeOutId = "";
      }
      this.msgTimeOutId = setTimeout(() => {
        this.msgStatus = false;
      }, 2000);
    },
    towerConfig() {
      if (!this.deviceId || this.deviceId == "") {
        // this.$message.error("未选中设备");
        this.msg = "未选中设备";
        this.type = "error";
        this.alertMsg();
        return;
      }
      myHttp
        .findWarningConfig({
          id: this.deviceId,
          projectId: util.session.get("groupId"),
        })
        .then((resp) => {
          if (resp.data.code == "200") {
            this.addfrom = resp.data.data || {
              //机器序列号
              id: "",
              //项目id
              projectId: util.session.get("groupId"),
              //设备名称
              name: "",
              //吊钩高度预警
              heightWarning: "",
              //吊钩高度报警
              heightAlarm: "",
              //小车幅度预警
              radiusWarning: "",
              //小车幅度报警
              radiusAlarm: "",
              //大臂回转预警
              angleWarning: "",
              //大臂回转报警
              angleAlarm: "",
              //吊起重量预警
              loadweightrWarning: "",
              //吊起重量报警
              loadweightrAlarm: "",
              //力矩百分比预警
              lijupercentWarning: "",
              //力矩百分比报警
              lijupercentAlarm: "",
              //姿态倾角预警
              fallWarning: "",
              //姿态倾角报警
              fallAlarm: "",
              //塔顶风速预警
              windspeedWarning: "",
              //塔顶风速报警
              windspeedAlarm: "",
            };
            this.addfrom.id = this.deviceId;
            this.addfrom.name = this.towerInfo.name;
            this.addfrom.projectId = util.session.get("groupId");
            this.addFormVisible = true;
          }
        });
    },
    backInitSetting() {
      this.addfrom = {
        //机器序列号
        id: "",
        //项目id
        projectId: util.session.get("groupId"),
        //设备名称
        name: "",
        //吊钩高度预警
        heightWarning: "",
        //吊钩高度报警
        heightAlarm: "",
        //小车幅度预警
        radiusWarning: "",
        //小车幅度报警
        radiusAlarm: "",
        //大臂回转预警
        angleWarning: "",
        //大臂回转报警
        angleAlarm: "",
        //吊起重量预警
        loadweightrWarning: "",
        //吊起重量报警
        loadweightrAlarm: "",
        //力矩百分比预警
        lijupercentWarning: "",
        //力矩百分比报警
        lijupercentAlarm: "",
        //姿态倾角预警
        fallWarning: "",
        //姿态倾角报警
        fallAlarm: "",
        //塔顶风速预警
        windspeedWarning: "",
        //塔顶风速报警
        windspeedAlarm: "",
      };
    },
    sumbitAddRow() {
      this.addfrom.id = this.deviceId;
      this.addfrom.name = this.towerInfo.name;
      this.addfrom.projectId = util.session.get("groupId");
      myHttp.addWarningConfig(this.addfrom).then((resp) => {
        this.msg = resp.data.msg;
        if (resp.data.code == 200) {
          // this.$message.success(resp.data.msg);
          this.type = "success";
          this.addFormVisible = false;
        } else {
          // this.$message.error(resp.data.msg);
          this.type = "error";
        }
        this.alertMsg();
      });
    },
    keyDown(event) {
      const e = event || window.event;
      if (e && e.keyCode === 122) {
        e.preventDefault();
        if (this.fullscreen) {
          this.exitFull(1);
        } else {
          this.handleFullScreen();
        }
      }
      if (e && e.keyCode === 27) {
        //esc退出全屏动作
        this.exitFull(0);
      }
    },
    // 按钮退出全屏
    exitFull(flag) {
      if (this.fullscreen == false) {
        return;
      }
      this.fullscreen = false;
      let element = document.getElementById("towerInfo");
      const runExit =
        element.exitFullscreen ||
        element.mozCancelFullScreen ||
        element.webkitExitFullscreen ||
        element.msExitFullscreen;
      if (runExit) runExit.call(element);
      else {
        if (flag == 1) {
          this.handleFullScreen();
        }
      }
    },
    handleFullScreen() {
      if (this.fullscreen == true) {
        return;
      }
      this.fullscreen = true;
      let element = document.getElementById("towerInfo");
      const runfullScreen =
        element.requestFullscreen ||
        element.mozRequestFullScreen ||
        element.webkitRequestFullScreen ||
        element.msRequestFullscreen;

      if (runfullScreen) runfullScreen.call(element);
      else {
        console.error("当前浏览器不支持部分全屏！");
      }
    },
    handleMessage(event) {
      if (event.data.status === "ok") {
        if (event.data.params.flag == 0) {
          if (event.data.params.status == 1) {
            if (this.fullscreen) {
              this.exitFull(1);
            } else {
              this.handleFullScreen();
            }
          } else {
            this.exitFull(0);
          }
        } else if (event.data.params.flag == 1) {
          this.deviceId = event.data.params.deviceId;
          this.tower = event.data.params;
          this.getTowerInfoById();
          this.recentWarningList();
          this.towerTeamsPersonList();
          this.findTowerBigScreenStatistics();
          this.getTowerSettings();
        } else if (event.data.params.flag == 2) {
          console.log(this.valData);
          if (event.data.params.data.tower.deviceId == this.deviceId) {
            let towerInfo = event.data.params.data.tower;
            this.handlerStatus(towerInfo.ownWarning, towerInfo);
            for (var i in this.valData) {
              this.valData[i] = towerInfo[i] * 1;
            }
            if (this.valData.ratedWeight == 0) {
              this.valData.ratedWeight = 5;
            }
          }
        } else if (event.data.params.flag == 3) {
          if (event.data.params.data.deviceId == this.deviceId) {
            let warnList = event.data.params.data.towerLog || [];
            warnList.forEach((item) => {
              item.createDate =
                util.myTime.formatTime(
                  item.createDate,
                  "YYYY-MM-dd HH:mm:ss"
                ) || "";
            });
            if (warnList.length) {
              const otherWarningList = warnList.filter(
                i => i.typeName !== '碰撞预警' && i.typeName !== '碰撞报警' && i.typeName !== '力矩预警' && i.typeName !== '力矩报警'
              );
              const crashWarningList = warnList.filter(i => i.typeName === '碰撞预警' || i.typeName === '碰撞报警');
              if (otherWarningList.length) {
                this.warnList = otherWarningList;
                  if (otherWarningList.length > this.warningConstantCount && !this.warningIntervalId) {
                      this.onMouseEnter1(-1);
                      this.warningIntervalId = setInterval(this.towerWarningInterval, 2000);
                  }
              }
              if (crashWarningList.length) {
                this.crashWarningList = crashWarningList;
                if (crashWarningList.length > this.warningConstantCount && !this.crashWarningIntervalId) {
                    this.onMouseEnter2(-1);
                    this.crashWarningIntervalId = setInterval(this.towerCrashWarningInterval, 2000);
                }
              }
            }
          }
        } else if (event.data.params.flag == 4) {
          this.statics = event.data.params.data.towerBigScreenStatistics;
        } else if (event.data.params.flag == 5) {
          if (event.data.params.data.tower.deviceId == this.deviceId) {
            let tower = event.data.params.data.tower;
            tower.createDate =
              util.myTime.formatTime(tower.createDate, "YYYY-MM-dd HH:mm:ss") ||
              "";
            this.towerInfo = tower;
            try {
              if (
                JSON.parse(event.data.params.data.tower.baseSetting).length !==
                0
              ) {
                this.datas = JSON.parse(
                  event.data.params.data.tower.baseSetting
                );
              } else {
                this.datas = this.copyDatas;
              }
            } catch (error) {
              this.datas = this.copyDatas;
            }
            this.towerHightInfo.hookHeightMax =
              this.datas.heightSettingBean.towerHeight * 1 ||
              this.towerHightInfo.hookHeightMax;
            this.towerHightInfo.carRangeMax =
              this.datas.rangeSettingBean.towerArmLength * 1 ||
              this.towerHightInfo.carRangeMax;
            this.towerHightInfo.liftingWeightMax =
              this.datas.weightSettingBean.weightRated * 1 ||
              this.towerHightInfo.liftingWeightMax;
            this.handlerStatus(this.towerInfo.ownWarning, this.towerInfo);
            for (var i in this.valData) {
              this.valData[i] = this.towerInfo[i] * 1;
            }
            if (this.valData.ratedWeight == 0) {
              this.valData.ratedWeight = 5;
            }
          }
        }
      }
    },
    personMoveInterval() {
      this.personMoveFlag = true;
      this.personTimeOutId = setTimeout(() => {
        this.teamsPersonList.shift();
        if (this.allTeamsPersonList.length <= this.personConstantCount) {
          if (
            this.teamsPersonList.length == this.allTeamsPersonList.length &&
            this.teamsPersonList[0].idcard == this.allTeamsPersonList[0].idcard
          ) {
            if (this.personIntervalId != "") {
              clearInterval(this.personIntervalId);
              this.personIntervalId = "";
            }
            if (this.personTimeOutId != "") {
              clearTimeout(this.personTimeOutId);
              this.personTimeOutId = "";
            }
            this.personMoveFlag = false;
            return;
          }
        }
        if (this.tempTeamsPersonList.length == 0) {
          this.tempTeamsPersonList = this.deepCopy(this.allTeamsPersonList);
        }
        this.teamsPersonList.push(this.deepCopy(this.tempTeamsPersonList[0]));
        this.tempTeamsPersonList.shift();
        this.personMoveFlag = false;
      }, 1000);
    },
        
    onMouseEnter1(index) {
        this.currentIndex1 = index;
        if (this.warningIntervalId) {
            clearInterval(this.warningIntervalId);
            this.warningIntervalId = undefined;
        }
        if (this.warningTimeOutId) {
            clearTimeout(this.warningTimeOutId);
            this.warningTimeOutId = undefined;
        }
    },

    onMouseLeave1() {
        this.currentIndex1 = -1;
        if (this.warningList.length >= this.warningConstantCount) {
            this.warningIntervalId = setInterval(this.towerWarningInterval, 2000);
        }
    },
    
    onMouseEnter2(index) {
        this.currentIndex2 = index;
        if (this.crashWarningIntervalId) {
            clearInterval(this.crashWarningIntervalId);
            this.crashWarningIntervalId = undefined;
        }
        if (this.crashWarningTimeOutId) {
            clearTimeout(this.crashWarningTimeOutId);
            this.crashWarningTimeOutId = undefined;
        }
    },

    onMouseLeave2() {
        this.currentIndex2 = -1;
        if (this.crashWarningList.length >= this.warningConstantCount) {
            this.crashWarningIntervalId = setInterval(this.towerCrashWarningInterval, 2000);
        }
    },
    onPersonEnterTd(index, e) {
      // this.messageContent = 'enter'
      this.personCurrentIndex = index;
      // console.log(index)
      if (this.personIntervalId != "") {
        clearInterval(this.personIntervalId);
        this.personIntervalId = "";
      }
      if (this.personTimeOutId != "") {
        clearTimeout(this.personTimeOutId);
        this.personTimeOutId = "";
      }
    },
    onPersonLeaveTd(e) {
      // this.messageContent = 'noEnter'
      this.personCurrentIndex = -1;
      // console.log(e)
      if (this.allTeamsPersonList.length > this.personConstantCount) {
        this.personIntervalId = setInterval(this.personMoveInterval, 2000);
      }
    },
    deepCopy(obj) {
      // 只拷贝对象
      if (typeof obj !== "object") return;
      // 根据obj的类型判断是新建一个数组还是一个对象
      var newObj = obj instanceof Array ? [] : {};
      for (var key in obj) {
        // 遍历obj,并且判断是obj的属性才拷贝
        if (obj.hasOwnProperty(key)) {
          // 判断属性值的类型，如果是对象递归调用深拷贝
          newObj[key] =
            typeof obj[key] === "object" ? this.deepCopy(obj[key]) : obj[key];
        }
      }
      return newObj;
    },
    getTowerInfoById() {
      myHttp
        .getTowerInfoByPage({ id: this.tower.tower.towerId })
        .then((resp) => {
          if (resp.data.code == 200) {
            this.towerInfo = resp.data.data.tower;
            console.log(resp.data.data);
            this.handlerStatus(this.towerInfo.ownWarning, this.towerInfo);
            for (var i in this.valData) {
              this.valData[i] = this.towerInfo[i] * 1;
            }
            if (this.valData.ratedWeight == 0) {
              this.valData.ratedWeight = 5;
            }
          }
        });
    },
    recentWarningList() {
      myHttp.recentWarningList({ projectId: this.projectId, deviceId: this.tower.deviceId }).then(res => {
        if (res.data.code === 200) {
            this.warningList = res.data.data.warningVos.filter(
              i => i.typeName !== '碰撞预警' && i.typeName !== '碰撞报警' && i.typeName !== '力矩预警' && i.typeName !== '力矩报警'
            ) || [];
            this.crashWarningList = res.data.data.warningVos.filter(i => i.typeName === '碰撞预警' || i.typeName === '碰撞报警') || [];
            if (this.warningList.length >= this.warningConstantCount) {
                this.onMouseEnter1(-1);
                this.warningIntervalId = setInterval(this.towerWarningInterval, 2000);
            }
            if (this.crashWarningList.length >= this.warningConstantCount) {
                this.onMouseEnter2(-1);
                this.crashWarningIntervalId = setInterval(this.towerWarningInterval, 2000);
            }
        } else {
            this.warningList = [];
            this.crashWarningList = [];
        }
      });
    },
 
    towerWarningInterval() {
        this.animate1 = true;
        this.warningTimeOutId = setTimeout(() => {
            this.warningList.push(this.warningList[0]);
            this.warningList.shift();
            this.animate1 = false;
        }, 1000);
    },

    towerCrashWarningInterval() {
        this.animate2 = true;
        this.crashWarningTimeOutId = setTimeout(() => {
            this.crashWarningList.push(this.crashWarningList[0]);
            this.crashWarningList.shift();
            this.animate2 = false;
        }, 1000);
    },
    towerTeamsPersonList() {
      myHttp
        .towerTeamsPersonList({
          teamsId: this.tower.tower.teamsId,
        })
        .then((resp) => {
          if (resp.data.code == 200) {
            this.teamsPersonList = resp.data.data || [];
            this.allTeamsPersonList = resp.data.data || [];
            if (this.allTeamsPersonList.length >= this.personConstantCount) {
              if (this.personIntervalId == "") {
                if (this.teamsPersonList.length == this.personConstantCount) {
                  this.teamsPersonList = this.teamsPersonList.concat(
                    this.allTeamsPersonList
                  );
                }
                let list = this.deepCopy(this.allTeamsPersonList);
                this.teamsPersonList = list.splice(0, this.personConstantCount);
                list = this.deepCopy(this.allTeamsPersonList);
                this.tempTeamsPersonList = list.splice(
                  this.personConstantCount,
                  list.length
                );
                this.personIntervalId = setInterval(
                  this.personMoveInterval,
                  2000
                );
              }
            } else {
              if (this.teamsPersonList.length == 0) {
                this.teamsPersonList = this.allTeamsPersonList;
              }
            }
          } else {
            this.teamsPersonList = [];
          }
          if (this.teamsPersonList.length > 0) {
            this.personNonImg = false;
          } else {
            this.personNonImg = true;
          }
        });
    },
    findTowerBigScreenStatistics() {
      myHttp
        .findTowerBigScreenStatistics({
          projectId: this.projectId,
        })
        .then((resp) => {
          if (resp.data.code == 200) {
            this.statics = resp.data.data.towerBigScreenStatistics;
          }
        });
    },
    getTowerSettings() {
      myHttp
        .getTowerSettings({
          imei: this.tower.deviceId,
        })
        .then((resp) => {
          if (resp.data.code == 200) {
            try {
              if (JSON.parse(resp.data.data.settings).length !== 0) {
                this.datas = JSON.parse(resp.data.data.settings);
              } else {
                this.datas = this.copyDatas;
              }
            } catch (error) {
              this.datas = this.copyDatas;
            }
            this.towerHightInfo.hookHeightMax =
              this.datas.heightSettingBean.towerHeight * 1 ||
              this.towerHightInfo.hookHeightMax;
            this.towerHightInfo.carRangeMax =
              this.datas.rangeSettingBean.towerArmLength * 1 ||
              this.towerHightInfo.carRangeMax;
            this.towerHightInfo.liftingWeightMax =
              this.datas.weightSettingBean.weightRated * 1 ||
              this.towerHightInfo.liftingWeightMax;
          }
        });
    },
    handlerStatus(warning, tower) {
      // console.log(tower);
      if (!warning || warning == "" || warning == 0) {
        for (let i = 0; i < this.initCharts.length; i++) {
          if (
            JSON.stringify(this.initCharts[i]) !==
            JSON.stringify(this.charsColors[0])
          ) {
            this.initCharts[i] = this.charsColors[0];
          }
        }
        return;
      }
      let warningArr = [];
      let warningList = warning.split(",");
      if (warningList && warningList.length > 0) {
        for (let i = 0; i < warningList.length; i++) {
          const ele = warningList[i];
          let index = -1;
          switch (ele * 1) {
            case 203:
              // tower.setStatus("3");
              // tower.setReasonStr("回转限位报警");
              // ownWarning += "203,";
              // ownWarningStr += "回转限位预警,";
              this.initCharts[3] = this.charsColors[1];
              index = 3;
              break;
            case 103:
              // tower.setStatus("2");
              // tower.setReasonStr("回转限位报警");
              // ownWarning += "103,";
              // ownWarningStr += "回转限位报警,";
              this.initCharts[3] = this.charsColors[2];
              index = 3;
              break;
            case 25:
              // tower.setStatus("3");
              // tower.setReasonStr("风速预警");
              // ownWarning += "25,";
              // ownWarningStr += "风速预警,";
              this.initCharts[0] = this.charsColors[1];
              index = 0;
              break;
            case 15:
              // tower.setStatus("2");
              // tower.setReasonStr("风速报警");
              // ownWarning += "15,";
              // ownWarningStr += "风速报警,";
              this.initCharts[0] = this.charsColors[2];
              index = 0;
              // this.$set(this.initCharts[0], this.charsColors[2]);
              break;
            case 202:
              // tower.setStatus("3");
              // tower.setReasonStr("高度限位预警");
              // ownWarning += "202,";
              // ownWarningStr += "高度限位预警,";
              this.initCharts[1] = this.charsColors[1];
              index = 1;
              break;
            case 102:
              // tower.setStatus("2");
              // tower.setReasonStr("高度限位报警");
              // ownWarning += "102,";
              // ownWarningStr += "高度限位报警,";
              this.initCharts[1] = this.charsColors[2];
              index = 1;
              break;
            case 201:
              // tower.setStatus("3");
              // tower.setReasonStr("幅度限位预警");
              // ownWarning += "201,";
              // ownWarningStr += "幅度限位预警,";
              this.initCharts[2] = this.charsColors[1];
              index = 2;
              break;
            case 101:
              // tower.setStatus("2");
              // tower.setReasonStr("幅度限位报警");
              // ownWarning += "101,";
              // ownWarningStr += "幅度限位报警,";
              this.initCharts[2] = this.charsColors[2];
              index = 2;
              break;
            case 22:
              // tower.setStatus("3");
              // tower.setReasonStr("重量预警");
              // ownWarning += "22,";
              // ownWarningStr += "重量预警,";
              this.initCharts[5] = this.charsColors[1];
              index = 5;
              break;
            case 12:
              // tower.setStatus("2");
              // tower.setReasonStr("重量报警");
              // ownWarning += "12,";
              // ownWarningStr += "重量报警,";
              this.initCharts[5] = this.charsColors[2];
              index = 5;
              break;
            case 24:
              // tower.setStatus("3");
              // tower.setReasonStr("倾斜预警");
              // ownWarning += "24,";
              // ownWarningStr += "倾斜预警,";
              this.initCharts[6] = this.charsColors[1];
              index = 6;
              break;
            case 14:
              // tower.setStatus("2");
              // tower.setReasonStr("倾斜报警");
              // ownWarning += "14,";
              // ownWarningStr += "倾斜报警,";
              this.initCharts[6] = this.charsColors[2];
              index = 6;
              break;
            case 23:
              // tower.setStatus("3");
              // tower.setReasonStr("力矩预警");
              // ownWarning += "23,";
              // ownWarningStr += "力矩预警,";
              this.initCharts[4] = this.charsColors[1];
              index = 4;
              break;
            case 13:
              // tower.setStatus("2");
              // tower.setReasonStr("力矩报警");
              // ownWarning += "13,";
              // ownWarningStr += "力矩报警,";
              this.initCharts[4] = this.charsColors[2];
              index = 4;
              break;
            case 114:
            case 113:
            case 112:
            case 111:
              // this.alarmInfo =
              //   tower.name + "(" + tower.deviceId + ")" + "碰撞报警";
              // this.alarmVisible = true;
              // if (this.alarmTimeOutId && this.alarmTimeOutId != "") {
              //   clearTimeout(this.alarmTimeOutId);
              //   this.alarmTimeOutId = "";
              // }
              // this.alarmTimeOutId = setTimeout(() => {
              //   this.alarmVisible = false;
              // }, 3000);
              // tower.setStatus("2");
              // tower.setReasonStr("碰撞报警");
              // ownWarning += "114,";
              // ownWarningStr += "碰撞报警,";
              break;
            case 211:
            case 212:
            case 213:
            case 214:
              // this.alarmInfo =
              //   tower.name + "(" + tower.deviceId + ")" + "碰撞预警";
              // this.alarmVisible = true;
              // if (this.alarmTimeOutId && this.alarmTimeOutId != "") {
              //   clearTimeout(this.alarmTimeOutId);
              //   this.alarmTimeOutId = "";
              // }
              // this.alarmTimeOutId = setTimeout(() => {
              //   this.alarmVisible = false;
              // }, 3000);
              // tower.setStatus("3");
              // tower.setReasonStr("碰撞预警");
              // ownWarning += "214,";
              // ownWarningStr += "碰撞预警,";
              break;
            default:
              break;
          }
          if (index != -1) {
            warningArr.push(index);
          }
        }
      }
      if (warningArr && warningArr.length > 0) {
        for (let i = 0; i < this.initCharts.length; i++) {
          if (!warningArr.includes(i)) {
            if (
              JSON.stringify(this.initCharts[i]) !=
              JSON.stringify(this.charsColors[0])
            ) {
              this.initCharts[i] = this.charsColors[0];
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tower-show-page {
  margin-top: 0.2vw;
  margin-left: 0.2vw;
  width: 99.8%;
  height: 99.6%;
  color: #ffffff;
  position: relative;
  font-family: PingFangSC-Medium;
  overflow: hidden;
}

.headBack {
  height: 12.3vh;
  position: absolute;
  z-index: 10;
  width: 100%;
  background-image: url("../../../assets/image/tower/bigScreen/towerBigScreenBack.png");
  background-size: cover;
}

.headFront {
  height: 12.3vh;
  position: absolute;
  background-position: 0 -5.3vh;
  z-index: 11;
  width: 100%;
  background-image: url("../../../assets/image/tower/bigScreen/towerBigScreenHead.png");
  background-size: cover;
}

.headTitle {
  font-size: 36px;
  font-weight: 500;
  top: 1vh;
}

.leftScreen {
  height: 100%;
  position: absolute;
  width: 25vw;
  z-index: 102;
  background: linear-gradient(90deg,
      #074676 0%,
      rgba(7, 70, 118, 0.47) 52%,
      rgba(2, 16, 27, 0.2) 100%);
}

.rightScreen {
  height: 100%;
  position: absolute;
  width: 25vw;
  right: 0;
  z-index: 102;
  background: linear-gradient(90deg,
      rgba(2, 16, 27, 0.2) 0%,
      rgba(7, 70, 118, 0.47) 52%,
      #074676 100%);
}

.line {
  background-color: #d8d8d8;
  width: 21.5vw;
  height: calc(0.1vh / var(--zoom));
  margin: calc(1.5vh / var(--zoom)) 0;
}

.screen-content {
  margin-top: 9vh;
  margin-left: calc(1.1vw / var(--zoom));
}

.machineStatus {
  text-align: left;
  color: #ffffff;
}

.machineStatusContent {
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  clear: both;
}

.machineStatusTitle {
  height: calc(2vh / var(--zoom));
  display: flex;
  width: 21.5vw;
}

.verticalBar {
  height: 100%;
  width: calc(0.2vw / var(--zoom));
  background: #26c3f7;
  box-shadow: 0 calc(0.1vh / var(--zoom)) calc(1.2vh / var(--zoom)) 0 #26c4f8;
}

.verticalBarTitle {
  font-size: 0.94rem;
  line-height: calc(2vh / var(--zoom));
  margin-left: calc(0.3vw / var(--zoom));
}

.earlyWarningSetting {
  font-size: 0.73rem;
  line-height: calc(2vh / var(--zoom));
  margin-left: calc(0.3vw / var(--zoom));
  color: #01ffff;
  position: absolute;
  right: 0;
  border: 0.1vh solid #0075ff;
  padding: 0.1vh 0.4vw;
  border-radius: 0.4vh;
  background: rgba(2, 84, 192, 0.01);
  box-shadow: inset 0 0.2vh 1vh 0 #0075ff;
}

.demonstration {
  font-size: 0.73rem;
  line-height: calc(2vh / var(--zoom));
  margin-left: calc(0.3vw / var(--zoom));
  color: #01ffff;
  position: absolute;
  right: 3vw;
  border: 0.1vh solid #0075ff;
  padding: 0.1vh 0.4vw;
  border-radius: 0.4vh;
  background: rgba(2, 84, 192, 0.01);
  box-shadow: inset 0 0.2vh 1vh 0 #0075ff;
}

.earlyWarningSetting:hover,
.demonstration:hover {
  cursor: pointer;
  background: #0075ff;
}

.machineStatusContent div {
  width: 28%;
  margin: calc(2vh / var(--zoom)) 2.5%;
}

.machineStatusContent div p {
  font-size: 0.73rem;
  margin-top: calc(1vh / var(--zoom));
  padding-left: calc(0.4vw / var(--zoom));
}

.machineStatusContent div p span {
  font-size: 1.146rem;
  display: inline-block;
  width: 2vw;
  text-align: center;
}

.check-charts div {
  margin: 1.5vh 0;
}

.check-charts {
  color: #ffffff;
  margin-top: 1.5vh;
  width: 45%;
}

.rightCheckContent {
  margin-left: 2vw;
  width: 45%;
}

.checkContent {
  display: flex;
}

.rightCheckContentTitle {
  width: 115%;
  height: 5vh;
  margin-top: 1.5vh;
  left: -1.7vw;
  background-image: url("../../../assets/image/tower/bigScreen/smallTitle.png");
  background-repeat: no-repeat;
  background-size: 100% 10vh;
  background-position: 0 -3vh;
}

.rightCheckContentInfoItem {
  margin-bottom: 2vh;
  background: linear-gradient(90deg,
      rgba(0, 106, 255, 0.1) -3%,
      rgba(0, 106, 255, 0) 100%);
}

.rightCheckContentInfoItem>div {
  display: flex;
  padding: calc(0.6vh / var(--zoom)) 0;
  padding-left: calc(0.6vh / var(--zoom));
}

.rightCheckContentInfoItem img {
  vertical-align: middle;
  margin-left: 0.2vw;
  width: 2.8vh;
  height: 2.8vh;
}

.rightCheckContentInfoItem p {
  margin-left: 0.2vw;
  font-size: 0.938rem;
  line-height: 22px;
}

.right-screen-content {
  margin-top: 9vh;
  margin-left: calc(2.2vw / var(--zoom));
}

.machineDetails {
  /*height: 33vh;*/
}

.machineDetailsInfo {
  text-align: left;
  margin-top: calc(1.5vh / var(--zoom));
  width: 21.5vw;
}

.machineDetailsInfo div {
  padding: calc(0.5vh / var(--zoom)) 0;
  margin-top: calc(0.5vh / var(--zoom));
  background: rgba(64, 208, 253, 0.01);
  box-sizing: border-box;
  width: 21.5vw;
  border: calc(0.1vh / var(--zoom)) solid #40d0fd;
  box-shadow: inset 0 calc(0.2vh / var(--zoom)) calc(1vh / var(--zoom)) 0 #40d0fd;
}

.machineDetailsInfo div p {
  font-size: 0.73rem;
  padding-left: calc(0.4vw / var(--zoom));
}

.machineDetailsInfo div p span {
  display: inline-block;
  margin-left: 0.5vw;
}

.earlyWarningRecordInfo {
  height: 16.5vh;
  overflow: hidden;
  margin-top: calc(1.5vh / var(--zoom));
}

.warningInfo {
  padding: calc(0.3vh / var(--zoom)) 0;
  margin-bottom: calc(0.8vh / var(--zoom));
  width: 21.5vw;
  padding-left: calc(0.3vw / var(--zoom));
  background: rgba(255, 0, 0, 0.01);
  white-space: nowrap;
  height: 3.5vh;
  overflow: hidden;
  box-sizing: border-box;
  border: linear-gradient(-45deg, transparent 1vh, #f07d17 0);
}

.alertColor {
  box-shadow: inset 0 calc(0.1vh / var(--zoom)) calc(1vh / var(--zoom)) 0 #fffd52;
}

.alarmColor {
  box-shadow: inset 0 calc(0.1vh / var(--zoom)) calc(1vh / var(--zoom)) 0 #ff4d52;
}

.earlyWarningRecord {
  /*height: 20vh;*/
  overflow: hidden;
}

.earlyWarningRecordInfo div div p {
  font-size: 0.834rem;
  margin-right: calc(0.6vw / var(--zoom));
  line-height: 2.8vh;
}

.personListInfo {
  width: 21.5vw;
  margin-top: 1.5vh;
  text-align: left;
}

.personListInfoTitle {
  display: flex;
  color: #04d3ff;
  background: linear-gradient(180deg, #0254c0 0%, rgba(2, 84, 192, 0) 100%);
}

.personListInfoTitle div {
  margin-right: 3%;
  font-size: 0.73rem;
}

.personListInfoContent div div {
  margin-top: calc(0.2vh / var(--zoom));
}

.personListInfoContent {
  overflow: hidden;
  height: 22vh;
}

.personList {
  /*height: 30vh;*/
  overflow: hidden;
}

.personInfo div {
  margin-right: 3%;
  font-size: 0.73rem;
  overflow: hidden;
}

.personName {
  width: 15%;
  white-space: nowrap;
  overflow: hidden;
}

.idCard {
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
}

.phone {
  width: 30%;
  white-space: nowrap;
  overflow: hidden;
}

.personInfo {
  white-space: nowrap;
  overflow: hidden;
  display: flex;
}

.move {
  transition: all 2s;
  transform: translateY(calc((3.9vh + (0.3vh / var(--zoom)) + (0.8vh / var(--zoom)) + (1vh / var(--zoom) / 2)) * -1));
}

.personMove {
  transition: all 1.5s;
  transform: translateY(-2.45vh);
}

.personEnter {
  cursor: pointer;
}

.personNoEnter {}

.warningConfig ::v-deep .el-dialog {
  background: rgba(7, 70, 118, 0.5);
  border-image-source: radial-gradient(60% 84%,
      transparent 0,
      transparent 100%,
      #3fcffc 100%);
  border-image-slice: 0.5;
  border-width: 0.15rem;
  border-style: solid;
  border-image-outset: 0cm;
  backdrop-filter: blur(1vh);
}

/*background: linear-gradient(to left, rgba(7, 70, 118, 0.5), rgba(7, 70, 118, 0.5))
      left top no-repeat,
    linear-gradient(to bottom, rgba(7, 70, 118, 0.5), rgba(7, 70, 118, 0.5)) left
      top no-repeat,
    linear-gradient(to left, rgba(7, 70, 118, 0.5), rgba(7, 70, 118, 0.5)) right top
      no-repeat,
    linear-gradient(to bottom, rgba(7, 70, 118, 0.5), rgba(7, 70, 118, 0.5)) right
      top no-repeat,
    linear-gradient(to left, rgba(7, 70, 118, 0.5), rgba(7, 70, 118, 0.5)) left
      bottom no-repeat,
    linear-gradient(to bottom, rgba(7, 70, 118, 0.5), rgba(7, 70, 118, 0.5)) left
      bottom no-repeat,
    linear-gradient(to left, rgba(7, 70, 118, 0.5), rgba(7, 70, 118, 0.5)) right
      bottom no-repeat,
    linear-gradient(to left, rgba(7, 70, 118, 0.5), rgba(7, 70, 118, 0.5)) right
      bottom no-repeat;
  设置大小
  background-size: 0.15rem 0.6rem, 0.6rem 0.15rem, 0.15rem 0.6rem,
    0.6rem 0.15rem;*/

.warningConfig ::v-deep .el-dialog__title {
  font-size: 0.938rem;
  letter-spacing: 0.1em;
  color: #ffffff;
}

.warningConfig ::v-deep .el-form-item__label {
  font-size: 0.834rem;
  font-weight: normal;
  letter-spacing: 0em;
  color: #ffffff;
}

.warningConfig .itemUnit {
  line-height: 3.1vh;
  font-size: 0.73rem;
  color: #fff;
  margin-left: 0.2vw;
  text-align: left;
  width: 2vw;
  height: 3.1vh;
}

.warningConfig ::v-deep .el-input {
  background: rgba(64, 208, 253, 0.01);
  box-sizing: border-box;
  border: 0.1vh solid #40d0fd;
  box-shadow: inset 0 0.2vh 1vh 0 #40d0fd;
}

.warningConfig ::v-deep .el-input__inner {
  background: rgba(64, 208, 253, 0.01);
  border: none;
  opacity: 0.6;
  font-size: 0.73rem;
  color: #ffffff;
}

.formItemInfo {
  margin-left: -1vw;
}

.cancle {
  border: 0.1vh solid rgba(255, 255, 255, 0.6);
  box-shadow: inset 0 0.2vh 1vh 0 rgba(255, 255, 255, 0.3);
  color: #fff;
}

.confirm {
  border: 0.1vh solid #0075ff;
  box-shadow: inset 0 0.2vh 1vh 0 #0075ff;
  color: #01ffff;
}

.confirm,
.cancle {
  text-align: center;
  line-height: 2.55vh;
  font-size: 0.73rem;
  width: 2.4vw;
  height: 2.55vh;
  border-radius: 0.4vh;
  background: rgba(2, 84, 192, 0.01);
  box-sizing: border-box;
}

.confirm:hover {
  cursor: pointer;
  background: #0075ff;
}

.cancle:hover {
  cursor: pointer;
  background: #afafaf;
}

.Box {
  position: fixed;
  top: 20%;
  left: calc(50% - 5vw);
  width: 10vw;
  height: 5vh;
  display: flex;
  overflow-x: hidden;
  overflow-y: hidden;
  justify-content: center;
  align-items: center;
  z-index: 999999;
}

.contentBox {
  width: 100%;
  height: 100%;
  background: rgba(7, 70, 118, 0.5);
  border-radius: 0.8vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* font-size:28px; */
}

.contentBox span {
  word-break: break-all;
}

.icon {
  font-size: 3vh;
  margin-bottom: 1vh;
}

.info {
  background: rgba(121, 115, 115, 0.5);
  border: 0.1vh solid rgb(121, 115, 115);
}

.success {
  border: 0.1vh solid rgba(7, 70, 118, 1);
}

.error {
  background: rgba(185, 11, 11, 0.5);
  border: 0.1vh solid rgb(185, 11, 11);
}

.alarmInfo {
  position: absolute;
  top: calc(50% - 10vh);
  z-index: 10000;
  width: 60vw;
  left: calc(50% - 30vw);
  text-align: center;
  height: 20vh;
  color: red;
  font-size: 2rem;
  line-height: 20vh;
  box-shadow: inset 0 0 4vh 0 red;
}

.textColorGradient {
  background: linear-gradient(#ffffff 50%, #59eaff);
  background-clip: text;
  color: transparent;
}
</style>